import type Button from '$lib/components/atoms/button/Button.svelte';
import type { ComponentProps } from 'svelte';

export const FAVORITES_MAX_NB = 15;

export const defaultNotificationCloseButtonProps = {
	variant: 'ghost',
	color: 'white',
	size: 'md',
	class: 'px-0',
} satisfies ComponentProps<typeof Button>;
